<template>
  <div class="calls-list-component">
    <CallsHeader 
      :show-title="showTitle"
      :can-add-call="canAddCall"
      @add-call="$emit('add-call')"
    >
      <template v-if="$slots['title-actions']" #title-actions>
        <slot name="title-actions"></slot>
      </template>
    </CallsHeader>
    
    <LoadingSpinner v-if="loading" position="fixed" message="Chargement des appels..." />
    
    <DetailEmpty v-else-if="calls.length === 0" tag="p" class="no-calls" text="Aucun appel enregistré" />
    
    <div v-else class="calls-list">
      <CallItem
        v-for="call in calls" 
        :key="call.id"
        :call="call"
        :can-edit="canEdit"
        :show-quote-link="showQuoteLink"
        @edit="$emit('edit-call', $event)"
        @delete="$emit('delete-call', $event)"
      />
    </div>
  </div>
</template>

<script setup>
import { CallItem, CallsHeader } from '.'
import LoadingSpinner from '../ui/LoadingSpinner.vue'
import DetailEmpty from '../data/DetailEmpty.vue'

const props = defineProps({
  calls: {
    type: Array,
    default: () => []
  },
  loading: {
    type: Boolean,
    default: false
  },
  canAddCall: {
    type: Boolean,
    default: false
  },
  canEdit: {
    type: Boolean,
    default: false
  },
  showQuoteLink: {
    type: Boolean,
    default: false
  },
  showTitle: {
    type: Boolean,
    default: true
  }
})

const emit = defineEmits(['add-call', 'edit-call', 'delete-call'])
</script>

<style scoped>
.calls-list-component {
  width: 100%;
}

/* La phrase d'absence des fiches (`DetailEmpty`) ; seul l'espace est local. */
.calls-list-component .no-calls {
  padding: var(--spacing-4) 0;
}

/* Les lignes portent leur propre filet de séparation : pas de gouttière. */
.calls-list {
  display: flex;
  flex-direction: column;
}
</style>

